import React from 'react';
import { BodyText, BodyTextSmall, Heading2, Modal, PrimaryButton } from '@kallidus/common';
import { useTranslation } from 'react-i18next';
import { HappyNews, RetryIcon } from '@Generic/icons';
import { isRecurredVersionMismatch } from '@ApplicationWide/version-checking';
import './VersionCheckModal.less';

const reloadPage = () => window.location.reload();

//Adapted from https://www.codemzy.com/blog/clients-reload-single-page-application-update
const VersionCheckModal = (modalProps) => {
  const { t } = useTranslation();
  const recurred = isRecurredVersionMismatch();
  return (
    <Modal
      className='version-check-modal'
      footer={React.Fragment}
      closeIcon={React.Fragment}
      maskClosable={false}
      keyboard={false}
      {...modalProps}
    >
      <HappyNews className='version-check-modal__image' />
      <Heading2 noTopSpacer className='version-check-modal__title'>
        {t('version-check.title')}
      </Heading2>
      <BodyText noTopSpacer className='version-check-modal__message'>
        {t('version-check.message')}
      </BodyText>
      {recurred && (
        <BodyTextSmall noTopSpacer className='version-check-modal__message'>
          {t('version-check.recurred')}
        </BodyTextSmall>
      )}
      <PrimaryButton className='version-check-modal__cta' onClick={reloadPage} iconStart={<RetryIcon />}>
        {t('version-check.cta')}
      </PrimaryButton>
    </Modal>
  );
};

export default VersionCheckModal;
